<template>
    <div>
        <div class="breadcrumb">
            <h1 style="color: #AC8400;">TBA Contacts</h1>
        </div>

        <!-- Breadcrumbs -->
        <div style="padding: 10px; background-color: #F2F2F2">
            <router-link to="/dashboard">Dashboard</router-link> / <b>TBA</b> / <b>Contacts</b>
        </div>

        <div class="separator-breadcrumb border-top"></div>

        <div class="px-3">
            <div class="row">
                <div class="col-md-6 mb-4" v-for="(assistanceItems, category) in data" :key="category">
                    <div class="card p-4 h-100">
                        <h2 class="text-capitalize font-bold mb-3">{{ category }}</h2>

                        <div v-for="(assistance, assistanceIndex) in assistanceItems"
                            :key="assistance.id || assistanceIndex">
                            <b>{{ assistance.name }}</b>
                            <div v-for="(contact, contactIndex) in assistance.contacts"
                                :key="contact.id || `new_${assistance.id}_${contactIndex}`" class="contact-item">
                                <div class="d-flex align-items-center mb-2" v-if="getFormData(contact, contactIndex)">
                                    <!-- Type -->
                                    <div class="mr-3">
                                        <label>Type</label>
                                        <div class="d-flex align-items-center">
                                            <div class="form-check mr-2">
                                                <input class="form-check-input" type="radio"
                                                    :name="'type' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    :id="'mobile' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    value="1"
                                                    v-model="getFormData(contact, contactIndex, assistance.id).type">
                                                <label class="form-check-label"
                                                    :for="'mobile' + (contact.id || `new_${assistance.id}_${contactIndex}`)">Mobile</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio"
                                                    :name="'type' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    :id="'whatsapp' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    value="2"
                                                    v-model="getFormData(contact, contactIndex, assistance.id).type">
                                                <label class="form-check-label"
                                                    :for="'whatsapp' + (contact.id || `new_${assistance.id}_${contactIndex}`)">WhatsApp</label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Phone Number -->
                                    <div class="mr-3">
                                        <label>Phone Number</label>
                                        <input type="text" class="form-control w-100" placeholder="Enter phone number"
                                            v-model="getFormData(contact, contactIndex, assistance.id).phoneNumber" />
                                    </div>

                                    <!-- Status -->
                                    <div class="mr-3">
                                        <label>Status</label>
                                        <div class="d-flex align-items-center">
                                            <div class="form-check mr-2">
                                                <input class="form-check-input" type="radio"
                                                    :name="'active' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    :id="'active' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    value="1"
                                                    v-model="getFormData(contact, contactIndex, assistance.id).status">
                                                <label class="form-check-label"
                                                    :for="'active' + (contact.id || `new_${assistance.id}_${contactIndex}`)">Active</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio"
                                                    :name="'active' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    :id="'inactive' + (contact.id || `new_${assistance.id}_${contactIndex}`)"
                                                    value="0"
                                                    v-model="getFormData(contact, contactIndex, assistance.id).status">
                                                <label class="form-check-label"
                                                    :for="'inactive' + (contact.id || `new_${assistance.id}_${contactIndex}`)">Inactive</label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Add / Update Button -->
                                    <button v-if="contact.id &&
                                        hasChanges(contact, contactIndex, assistance.id)"
                                        class="btn btn-primary ml-auto"
                                        @click="handleAddOrUpdate(contact, assistance, contactIndex)" :disabled="!isFormValid(contact, contactIndex, assistance.id) ||
                                            !hasChanges(contact, contactIndex, assistance.id)">
                                        Update
                                    </button>

                                    <button v-if="!contact.id" class="btn btn-primary ml-auto"
                                        @click="handleAddOrUpdate(contact, assistance, contactIndex)"
                                        :disabled="!isFormValid(contact, contactIndex, assistance.id)">
                                        Add
                                    </button>

                                </div>
                            </div>

                            <hr v-if="assistance.contacts.length > 1 && assistanceIndex !== assistanceItems.length - 1">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Success/Error Messages -->
        <div v-if="message" class="alert" :class="messageType === 'success' ? 'alert-success' : 'alert-danger'"
            role="alert">
            {{ message }}
        </div>
    </div>
</template>

<script>
import { getEmergencyNumber, storeEmergencyNumber, updateEmergencyNumber } from '../../../services/EmergencyNumberService';

export default {
    name: "tba-contacts",
    data() {
        return {
            data: {},
            formData: {},
            originalFormData: {},
            message: '',
            messageType: 'success',
        };
    },
    mounted() {
        this.initializeFormData();
    },
    methods: {
        async initializeFormData() {
            try {
                const response = await getEmergencyNumber();

                if (response.data.success) {
                    this.data = response.data.data || {};

                    // Initialize formData for all contacts
                    Object.keys(this.data).forEach(category => {
                        this.data[category].forEach(assistance => {
                            if (!Array.isArray(assistance.contacts)) {
                                assistance.contacts = [];
                            }
                            // Prefill existing contacts and ensure formData exists
                            assistance.contacts.forEach((contact, index) => {
                                this.ensureFormDataExists(contact, index, assistance.id);
                            });

                            // Add empty row for new contact
                            const newContact = { id: null };
                            assistance.contacts.push(newContact);
                            this.ensureFormDataExists(newContact, assistance.contacts.length - 1, assistance.id);
                        });
                    });
                } else {
                    console.error(response.data.message);
                }
            } catch (error) {
                console.error(error);
            }
        },

        ensureFormDataExists(contact, index, assistanceId) {
            const key = contact.id || `new_${assistanceId}_${index}`;
            if (!this.formData[key]) {
                const initialData = {
                    type: contact.type ? String(contact.type) : '1',
                    phoneNumber: contact.phone_number || '',
                    status: contact.status != null ? String(contact.status) : '1'
                };

                this.$set(this.formData, key, initialData);

                // Also store the original values for comparison
                this.$set(this.originalFormData, key, { ...initialData });
            }
            return key;
        },

        getFormData(contact, index, assistanceId) {
            const key = contact.id || `new_${assistanceId}_${index}`;
            if (!this.formData[key]) {
                this.ensureFormDataExists(contact, index, assistanceId);
            }
            return this.formData[key];
        },

        isFormValid(contact, index, assistanceId) {
            const key = contact.id || `new_${assistanceId}_${index}`;
            const entry = this.formData[key];

            return entry && entry.phoneNumber && entry.type && entry.status;
        },

        hasChanges(contact, index, assistanceId) {
            const key = contact.id || `new_${assistanceId}_${index}`;
            const current = this.formData[key];
            const original = this.originalFormData[key];

            if (!current || !original) return false;

            return (
                current.type !== original.type ||
                current.phoneNumber !== original.phoneNumber ||
                current.status !== original.status
            );
        },

        handleAddOrUpdate(contact, assistance, index) {
            const key = contact.id || `new_${assistance.id}_${index}`;
            const entry = this.formData[key];

            if (!this.isFormValid(contact, index, assistance.id)) {  // ✅ add assistance.id
                this.showMessage('Please fill in all required fields', 'error');
                return;
            }

            if (!this.isValidPhoneNumber(entry.phoneNumber)) {
                this.showMessage('Please enter a valid phone number', 'error');
                return;
            }

            const submissionData = {
                id: contact.id ? contact.id : null,
                assistance_id: assistance.id,
                assistance_name: assistance.name,
                type: parseInt(entry.type),
                phone_number: entry.phoneNumber,
                status: parseInt(entry.status),
            };

            this.submitContactData(submissionData, assistance, index, contact.id == null);
        },

        async submitContactData(data, assistance, index, isNew) {
            try {
                console.log('Submitting contact data:', data);
                let response;
                if (isNew) {
                    response = await storeEmergencyNumber(data);
                } else {
                    response = await updateEmergencyNumber(data.id, data);
                }

                if (response.data.success) {
                    this.showMessage(
                        `Contact for "${data.assistance_name}" ${isNew ? 'added' : 'updated'} successfully!`,
                        'success'
                    );
                    this.initializeFormData();
                }

                // If it was a new contact, push another empty row
                if (isNew) {
                    const newContact = { id: null };
                    assistance.contacts.push(newContact);
                    this.ensureFormDataExists(newContact, assistance.contacts.length - 1);
                }
            } catch (error) {
                console.error('Error submitting contact data:', error);
                this.showMessage(error, 'error');
            }
        },

        isValidPhoneNumber(phoneNumber) {
            const phoneRegex = /^\+?[\d\s\-\(\)]{7,15}$/;
            return phoneRegex.test(phoneNumber);
        },

        showMessage(text, type) {
            this.message = text;
            this.messageType = type;
            setTimeout(() => (this.message = ''), 5000);
        },
    },
};
</script>

<style scoped>
.alert {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    min-width: 300px;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.contact-item {
    margin-bottom: 15px;
}
</style>